import axios from 'axios'
import { Message } from 'element-ui'

axios.interceptors.response.use(
  success => {
    if (success.status && success.status === 200 &&
      (success.data.code === 500 || success.data.code === 400)) {
      Message.error({ message: success.data.message })
      return
    }
    // if (success.data.message) {
    //   Message.success({ message: success.data.message })
    // }
    return success.data
  },
  error => {
    if (error && error.response && error.response.status === 504) {
      Message.error({ message: '服务器错误' })
    } else if (error && error.response && error.response.status === 404) {
      Message.error({ message: '请求错误,未找到该资源' })
    } else if (error && error.response && error.response.status === 403) {
      Message.error({ message: '禁止访问' })
    } else {
      if (error && error.message === 'Network Error') {
        Message.error({ message: '网络错误' })
      } else if (error && error.response && error.response.data.message) {
        Message.error({ message: error.response.data.message })
      } else {
        Message.error({ message: error })
      }
    }
  }
)

const base = ''

export const postKeyValueRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const i in data) {
          ret +=
            encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const postRequest = (url, params, responseType) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    responseType: responseType
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params
  })
}
export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params
  })
}
export const deleteRequest = (url, params) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    params: params
  })
}
